<div [formGroup]="workTeamForm" (ngModelChange)="onFormChange()" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
  <!-- Sección Fechas de Alta -->
  <div class="form-title-container">
    <h4>Fechas de Alta</h4>
  </div>

  <div class="columns is-multiline">
    <div class="column is-6 form-container">
      <span class="label">Fecha de alta total</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="totalStartDate"
        formControlName="totalStartDate"
      />
    </div>
  </div>

  <h5>Área Contable</h5>
  <div class="columns is-multiline">
    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios recurrentes</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="accountingRecurrentStartDate"
        formControlName="accountingRecurrentStartDate"
      />
    </div>

    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="accountingStartDate"
        formControlName="accountingStartDate"
      />
    </div>
  </div>

  <h5>Área Laboral</h5>
  <div class="columns is-multiline">
    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios recurrentes</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="laborRecurrentStartDate"
        formControlName="laborRecurrentStartDate"
      />
    </div>

    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="laborStartDate"
        formControlName="laborStartDate"
      />
    </div>
  </div>

  <h5>Área Fiscal</h5>
  <div class="columns is-multiline">
    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios recurrentes</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="fiscalRecurrentStartDate"
        formControlName="fiscalRecurrentStartDate"
      />
    </div>

    <div class="column is-6 form-container">
      <span class="label">Fecha alta servicios</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="fiscalStartDate"
        formControlName="fiscalStartDate"
      />
    </div>
     <!-- 
    <div class="column is-12 container">
    <span class="label">Observaciones</span>
    <textarea class="search-input padding-4" pInputText formControlName="observations" rows="3" style="min-height: 5rem;"></textarea>
  </div> -->
  </div>
 

  <!-- Sección Equipo de Trabajo -->
  <div class="section-divider"></div>
    <div class="form-title-container">
      <h4>Equipo de Trabajo</h4>
    </div>

    <div class="columns is-multiline">
      <div class="column is-3 form-container">
        <h5>Área Contable</h5>
        <span class="label">Responsable</span>
        <p-dropdown
          [options]="accountingUsers"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar responsable'"
          formControlName="accountingResponsible"
          [showClear]="true"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        <span class="label" style="margin: 15px 0 5px 0">Colaboradores</span>
        <p-multiSelect
          [options]="accountingUsers"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} colaboradores seleccionados"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar colaboradores'"
          formControlName="accountingCollaborators"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        @if (getSelectedCollaborators('accountingCollaborators').length > 0) {
        <div class="collaborators-list-box">
          <ol class="collaborators-list" type="1">
            @for (collaborator of
            getSelectedCollaborators('accountingCollaborators'); track
            collaborator.id) {
            <li>{{ collaborator.name }}</li>
            }
          </ol>
        </div>
        }
      </div>

      <div class="column is-3 form-container">
        <h5>Área Laboral</h5>
        <span class="label">Responsable</span>
        <p-dropdown
          [options]="laborUsers"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar responsable'"
          formControlName="laborResponsible"
          [showClear]="true"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        <span class="label" style="margin: 15px 0 5px 0">Colaboradores</span>
        <p-multiSelect
          [options]="laborUsers"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} colaboradores seleccionados"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar colaboradores'"
          formControlName="laborCollaborators"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        @if (getSelectedCollaborators('laborCollaborators').length > 0) {
        <div class="collaborators-list-box">
          <ol class="collaborators-list" type="1">
            @for (collaborator of
            getSelectedCollaborators('laborCollaborators'); track
            collaborator.id) {
            <li>{{ collaborator.name }}</li>
            }
          </ol>
        </div>
        }
      </div>

      <div class="column is-3 form-container">
        <h5>Área Fiscal</h5>
        <span class="label">Responsable</span>
        <p-dropdown
          [options]="fiscalUsers"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar responsable'"
          formControlName="fiscalResponsible"
          [showClear]="true"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        <span class="label" style="margin: 15px 0 5px 0">Colaboradores</span>
        <p-multiSelect
          [options]="fiscalUsers"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} colaboradores seleccionados"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar colaboradores'"
          formControlName="fiscalCollaborators"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />

        @if (getSelectedCollaborators('fiscalCollaborators').length > 0) {
        <div class="collaborators-list-box">
          <ol class="collaborators-list" type="1">
            @for (collaborator of
            getSelectedCollaborators('fiscalCollaborators'); track
            collaborator.id) {
            <li>{{ collaborator.name }}</li>
            }
          </ol>
        </div>
        }
      </div>

      <div class="column is-3 form-container">
        <h5>Facturación</h5>
        <span class="label">Responsable</span>
        <p-dropdown
          [options]="invoicingUsers"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar responsable'"
          formControlName="invoicingResponsible"
          [showClear]="true"
          [emptyFilterMessage]="'No se encontraron resultados'"
          class="search-input"
        />
      </div>
    </div>
  </div>

  <div class="columns is-multiline">
    <div class="column is-12 form-container">
      <span class="label">Observaciones</span>
      <textarea pInputTextarea [autoResize]="true" formControlName="observations" rows="3" class="search-input observations-field" maxlength="2000"></textarea>
    </div>
  </div>

<div class="save-button-container">
  <button class="button save-button is-secondary" (click)="save()" [disabled]="isSubmitting">
    <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar
  </button>
</div>

@if (submitError) {
  <div class="notification is-danger">
    <button class="delete" (click)="submitError = ''"></button>
    <div class="notification-text">{{ submitError }}</div>
  </div>
}

@if (isSaved()) {
  <div class="notification is-success">
    <div class="notification-text">
      Guardado correctamente.
    </div>
    <div class="progress-bar-container">
      <progress class="progress is-small" min="0" max="100"></progress>
    </div>
  </div>
}
